import React, { useState } from "react";
import { HeartHandshake } from "lucide-react";
import { ProspectWelcome } from "@/components/nds/partnerWelcome/ProspectWelcome";

/** Public "Resident Welcome": the narrated welcome partners play for new referrals. No login, nothing recorded. */
export const ResidentWelcomeButton = ({ className = "", style, label = "The Journey", testid = "resident-welcome-btn", children }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} data-testid={testid} className={className} style={style}>
        {children || <><HeartHandshake className="h-4 w-4" /> {label}</>}
      </button>
      {open && <ProspectWelcome site replay onDone={() => setOpen(false)} onClose={() => setOpen(false)} />}
    </>
  );
};
